import { render, staticRenderFns } from "./calyrafit-text-with-icon.vue?vue&type=template&id=674bbdda&scoped=true&"
import script from "./calyrafit-text-with-icon.vue?vue&type=script&lang=js&"
export * from "./calyrafit-text-with-icon.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-text-with-icon.vue?vue&type=style&index=0&id=674bbdda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674bbdda",
  null
  
)

export default component.exports